var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppointmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 60,
    viewBox: "0 0 77 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.3462 5.4668H9.65385C4.87446 5.4668 1 8.4627 1 12.1583V52.3076C1 56.0032 4.87446 58.9991 9.65385 58.9991H67.3462C72.1255 58.9991 76 56.0032 76 52.3076V12.1583C76 8.4627 72.1255 5.4668 67.3462 5.4668Z",
    stroke: "#596394",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76 16.6136H1M15.4231 1V5.46102V1ZM61.5769 1V5.46102V1Z",
    stroke: "#596394",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentIcon);
export default __webpack_public_path__ + "static/media/appointmentIcon.114dcad7cba35bd68eaac919c1cd9137.svg";
export { ForwardRef as ReactComponent };